export default function InlineLoader (){

    return(
        <div className="inline-loader">
        </div>
    )

}